export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks2.730e36ce.jpg";